import { render, staticRenderFns } from "./formCreate.vue?vue&type=template&id=266831eb&scoped=true&"
import script from "./formCreate.vue?vue&type=script&lang=js&"
export * from "./formCreate.vue?vue&type=script&lang=js&"
import style0 from "./formCreate.vue?vue&type=style&index=0&id=266831eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266831eb",
  null
  
)

export default component.exports